import { render } from "./PonTreeOnu.vue?vue&type=template&id=e8f89f4c&scoped=true"
import script from "./PonTreeOnu.vue?vue&type=script&lang=js"
export * from "./PonTreeOnu.vue?vue&type=script&lang=js"

import "./PonTreeOnu.vue?vue&type=style&index=0&id=e8f89f4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8f89f4c"]])

export default __exports__